import { authHeader, handleResponse } from './helper';
import config from '../config';
import { getCookie } from './cookies';

export const checkCompletedResults = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),

    },
  };

  const url = new URL(`${config.apiLaboratoryUrl}/bupa/checkCompletedResults`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getStructuredResults = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/laboratories/getOrders`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
};

export const sendOrderToBupa = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiLaboratoryBupaUrl}/order/sendOrder`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const sendOrderToBionet = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiLaboratoryBionetUrl}/order/sendOrder`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const sendOrderToSofsalud = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branchOfficeId: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiLaboratorySofsaludUrl}/order/sendOrder`);
  return await fetch(url, requestOptions).then(handleResponse);
}

const getLaboratoryExams = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/exams/getExamsBy`);

  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const laboratoryService = {
  checkCompletedResults,
  getStructuredResults,
  getLaboratoryExams,
  sendOrderToBupa,
  sendOrderToBionet,
  sendOrderToSofsalud,
};